import { BLOCKING_CONVERSATION_EVENT_TYPES, EventType } from '@/features/events/shared'
import { getLatestConversationTurn } from '@/features/events/conversation/state/types'
import type {
  ClaudeSession,
  ConversationTurnEntry,
} from '@/features/events/conversation/state/types'
import { isCommandPending } from '@/features/events/conversation/controls/utils'

export function getPendingBlockingEvent(session: ClaudeSession): ConversationTurnEntry | null {
  const latestTurn = getLatestConversationTurn(session)
  if (!latestTurn) return null

  const latestEvent = latestTurn.events.at(-1)
  if (!latestEvent) return null

  // BLOCKING_CONVERSATION_EVENT_TYPES intentionally INCLUDES AGENT_REPLY (used elsewhere),
  // so this explicit guard must precede the set check to exclude replies from the inbox.
  if (latestEvent.eventType === EventType.AGENT_REPLY) return null

  const isBlocking =
    BLOCKING_CONVERSATION_EVENT_TYPES.has(latestEvent.eventType) ||
    latestEvent.eventType === EventType.ERRORED_EVENT
  if (!isBlocking) return null

  const latestCommand = latestTurn.userCommands.at(-1)
  if (isCommandPending(latestCommand, latestEvent)) return null

  return latestEvent
}
